import { InMemoryActivityRepository } from "./InMemoryActivityRepository";
import { InMemoryClientRepository } from "./InMemoryClientRepository";
import { InMemoryInvoiceRepository } from "./InMemoryInvoiceRepository";
import { InMemoryPetRepository } from "./InMemoryPetRepository";
import { InMemoryReportRepository } from "./InMemoryReportRepository";
import { InMemorySettingsRepository } from "./InMemorySettingsRepository";
import { InMemoryVetRepository } from "./InMemoryVetRepository";
import { store } from "./store";

// Singleton instances over a single shared store — the provider can be
// mounted more than once (index.tsx and App.tsx both wrap children in it)
// and every mount must see the same data.
export const inMemoryRepositories = {
  clients: new InMemoryClientRepository(store),
  invoices: new InMemoryInvoiceRepository(store),
  vets: new InMemoryVetRepository(store),
  pets: new InMemoryPetRepository(store),
  activities: new InMemoryActivityRepository(store),
  settings: new InMemorySettingsRepository(store),
  reports: new InMemoryReportRepository(store),
};
